import styled, { keyframes, css } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

// Chip flutuante no canto superior direito, visivel em todas as telas
// autenticadas. Operador 24/7 sempre sabe se a conexao do navegador
// esta ativa e ha quanto tempo nao chega dado novo.
export const Chip = styled.div`
  position: fixed;
  top: 12px;
  right: 16px;
  z-index: 5;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.card};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  box-shadow: none;
  font-size: 11px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.label};
  letter-spacing: 0.2px;
  transition: opacity 200ms;

  /* Em viewport bem estreito ou tela de login, escondemos para nao
     poluir. As telas autenticadas tem padding superior suficiente. */
  @media (max-width: 720px) {
    top: 8px;
    right: 8px;
    padding: 4px 10px;
    font-size: 10px;
  }
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => {
    if (props.status === 'offline') return props.theme.colors.red;
    if (props.status === 'stale') return props.theme.colors.yellow || '#F6DE60';
    return props.theme.colors.green;
  }};
  flex-shrink: 0;
  ${(props) =>
    props.status === 'offline' &&
    css`
      animation: ${pulse} 1.2s ease-in-out infinite;
    `}
`;

export const Strong = styled.strong`
  color: ${(props) => props.theme.colors.darkerblue};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

// Variante discreta para o rodape do side-menu: sem position fixed, sem
// box-shadow. Quando o menu esta colapsado mostra so o dot; quando aberto
// expande para mostrar o texto. Adapta o layout pelo prop `open`.
export const SidebarChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? props.theme.colors.background || 'rgba(0,0,0,0.03)'
      : 'rgba(255,255,255,0.04)'};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  font-size: 10px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.label};
  letter-spacing: 0.2px;
  white-space: nowrap;
  min-width: 0;
  /* Quando o sidebar esta colapsado, vira so o dot (sem padding lateral). */
  ${(props) =>
    !props.open &&
    `
      padding: 4px;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      gap: 0;
      justify-content: center;
    `}
`;

export const SidebarLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;
